import { motion } from "framer-motion";
import { useTheme } from "../contexts/ThemeContext";

export default function AnimatedButton({ 
  children, 
  onClick, 
  variant = "primary", 
  size = "md", 
  disabled = false,
  className = "",
  icon = null
}) {
  const { isDark } = useTheme();
  const baseClasses = "font-medium rounded-xl transition-all duration-200 flex items-center justify-center gap-2";
  
  const variants = {
    primary: isDark 
      ? "bg-gradient-to-r from-gray-500 to-gray-600 text-white hover:from-gray-600 hover:to-gray-700"
      : "bg-gradient-to-r from-blue-500 to-blue-600 text-white hover:from-blue-600 hover:to-blue-700",
    secondary: isDark
      ? "bg-gray-800 border-2 border-gray-500 text-gray-300 hover:bg-gray-700"
      : "bg-white border-2 border-blue-500 text-blue-500 hover:bg-blue-50",
    danger: "bg-gradient-to-r from-red-500 to-red-600 text-white hover:from-red-600 hover:to-red-700",
    success: "bg-gradient-to-r from-green-500 to-green-600 text-white hover:from-green-600 hover:to-green-700"
  };

  const sizes = {
    sm: "px-3 py-2 text-sm",
    md: "px-4 py-3 text-base",
    lg: "px-6 py-4 text-lg"
  };

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      whileHover={!disabled ? { 
        scale: 1.02, 
        y: -2,
        boxShadow: "0 10px 25px rgba(0,0,0,0.1)"
      } : {}}
      whileTap={!disabled ? { scale: 0.98 } : {}}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      {icon && (
        <motion.span
          animate={{ rotate: [0, 360] }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        >
          {icon}
        </motion.span>
      )}
      {children}
    </motion.button>
  );
}